// extracted by mini-css-extract-plugin
module.exports = {"container":"UserDisplayNameViewerV2_container__ik_RE","displayNameContainer":"UserDisplayNameViewerV2_displayNameContainer__h3VZy","icon":"UserDisplayNameViewerV2_icon__RrMjm"};